module.exports = __webpack_public_path__ + "img/cooperation_bg_quanqiuwa@.b3060557.png";